import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/libs/vant'
import "@/styles/index.scss"; // 全局引入reset css
import { Toast } from 'vant';
import setupDirective from '@/directive/setup'
import { storeSet, storeGet, storeDel } from '@/utils/localStore';
import vConsole from 'vconsole';
import { onCheckHasConsole } from './utils'
import { wxsdkInit } from './utils/weixin'  

Vue.config.productionTip = false
Vue.use(Toast);

// wxsdkInit()

console.log('内网灰度 1.0.1')

setupDirective(Vue)
// 本地缓存全局方法
Vue.prototype.$storeSet = storeSet;
Vue.prototype.$storeGet = storeGet;
Vue.prototype.$storeDel = storeDel;

if (onCheckHasConsole()) {
  new vConsole();
}

require("@/libs/rem.js"); // 引入全局rem函数
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
